import userManagement from '../apis/userManagement.api';
import { AxiosResponse } from 'axios';
import { LandingPageAccess } from '../types';

export const getLandingPageAccess = (): Promise<
	AxiosResponse<LandingPageAccess>
> => {
	return userManagement.get('user/admin');
};
